import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { RfqCacheService } from '../../../dashboard/rfq-cache.service';
import { FormBuilder, FormControl, FormArray, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { BuyerService } from 'src/app/views/settings/buyers/buyer.service';
import { Page } from 'src/app/shared/models/page';
import { SettingsService } from 'src/app/views/settings/settings.service';
import { Observable } from 'rxjs';
import { AutoCompleteDataType, Currency, incoterms, offeredQuality, portData, quoteAttachmentType, supplierBranchData, Vessel } from 'src/app/shared/models/settings.model';
import { v4 as uuidv4 } from "uuid";
import { NgxFileDropEntry } from 'ngx-file-drop';
import { AttachmentTypes } from 'src/app/shared/common/Enums';
import { AwsSdkService } from 'src/app/shared/services/aws-sdk.service';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { MatRadioChange } from '@angular/material/radio';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { RfqGenerateFormService } from '../../../dashboard/rfq/rfq-generate-form/rfq-genearte-form.service';
import { QuoteService } from '../../../dashboard/quote/quote.service';
import { SupplierService } from 'src/app/views/settings/suppliers/supplier.service';
import { DataTransferService } from 'src/app/shared/services/data-transfer.service';
import { PurchaseOrderService } from '../purchase-order.service';

@Component({
  selector: 'app-purchase-order-payment-terms',
  templateUrl: './purchase-order-payment-terms.component.html',
  styleUrls: ['./purchase-order-payment-terms.component.css']
})
export class PurchaseOrderPaymentTermsComponent implements OnInit{


  isForm1Expand: boolean = true;
  isForm2Expand: boolean = true;
  isForm3Expand: boolean = true;

  rfqId!: number;
  quoteId!: number;
  purchaseOrderId!:number;
  isSaved: boolean = false;
  currentTab: string = 'payment-terms';
  tabEnabled: boolean = false;

  paymentFormGroup!: UntypedFormGroup;
  buyerFormGroup!: UntypedFormGroup;

  buyerStreet:any;
  buyerCity:any;
  buyerZipCode:any;
  buyerStateCode:any;
  buyerCountry:any;


  showNotification: boolean = false;
  notificationMessage: string = '';
  notificationTitle: string = '';
  notificationType: 'error' | 'info' = 'error';
  taxStatusData:any[]=[]


  selectedTermsConditionIndex!:number | null
  // showAddDocumentSection: boolean = false;
  // showAddCommentsSection: boolean = false;
  newfileuploaded:boolean=false;
  uploadedAttachmentsArray: any[] = []; 
  uploadedAdditionalAttachmentsArray: any[] = []; 
  acceptedAttachmentExtenstion: any = ['.pdf', '.jpg', '.jpeg', '.png'];
  maxFileSize: number = 10 * 1024 * 1024; //10MB
  previewSection:boolean = false
  previewDoc:any[]=[]
  currentIndex = 0;

  portAgentData: any[] = []
  billingAddressData: any[] = []
  billingAddress!:string;

  tabs: any[] = [
    {
      index: 0,
      label: 'LINE ITEMS',
      icon: "directions_boat",
      route: 'line-items',
    },
    {
      index: 1,
      label: 'HEADER DETAILS',
      icon: "looks",
      route: 'header',
    },
    {
      index: 2,
      label: 'PAYMENT TERMS',
      icon: "location_searching",
      route: 'payment-terms',
    },{
      index:3,
      label: 'PREVIEW',
      icon: "location_searching",
      route: 'preview',
    }
  ];

  showConfirmationDialogue: boolean = false
  showSuccessDialogue: boolean = false
  showCloseDialogue: boolean = false;
  headerData:any;
  showDeclineConfirmationDialogue:boolean=false


  constructor(
    private snack: MatSnackBar,
    private rfqCacheService: RfqCacheService,
    private _formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private CookieService: CookieService,
    private BuyerService: BuyerService,
    private router: Router,
    private SettingsService: SettingsService,
    private fb: FormBuilder,
    private awsSdkService: AwsSdkService,
    private webApiService: WebApiService,
    private ls: LocalStoreService,
    private fullLoaderService: FullLoaderService,
    private activatedRoute: ActivatedRoute,
    private RfqGenerateFormService:RfqGenerateFormService,
    private cookieService: CookieService,
    private quoteService: QuoteService,
    private supplierService:SupplierService,
    private dataTransferService: DataTransferService<any>,
    private purchaseOrderService: PurchaseOrderService

  ) {
  };


  async ngOnInit() {
    this.fullLoaderService.showLoader();

    this.paymentFormGroup = this._formBuilder.group({
        // Buyer Payment Terms
        billingAddress: [''],
        billingAddressType: [''],
        applicableTaxProfile: [''],
        buyersPaymentTerms: [''],
        buyerTermsAndConditions: [''],

        // Port Agent Details (portAgentId is mandatory)
        portAgentId: ['', Validators.required],
        portAgencyName: [''],
        portAgentName: [''],
        portAgentPhoneNumber: [''],
        portAgentContact: [''],
        portAgentPhoneFax: [''],
        portAgentEmail: [''],
        portAgentAddress: [''],

        // Terms and Conditions (file upload + text)
        termsAndConditions: [''],
        attachments: [null]
     });

    this.activatedRoute.queryParams.subscribe(async params => {


      if (params['rfqId'] != '' && params['quoteId'] != '' && params['purchaseOrderId']!='') {

        this.rfqId = params['rfqId']
        this.quoteId = params['quoteId']
        this.purchaseOrderId = params['purchaseOrderId']

        this.fullLoaderService.showLoader()

        //  this.getQuoteDraftData()
          let param={
            purchaseOrderId:this.purchaseOrderId,
            section: "paymentTerms"
          }
          const result= await this.purchaseOrderService.fetchPurchaseOrder(param);
          console.log({result});
          const response = result[0];
          // Update form values
          this.billingAddress = response.billingAddress;
          this.paymentFormGroup.patchValue({
            // billingAddress: response.invoiceAddressType==2 ? response.billingAddress:'',
            billingAddress: response.billingAddress,
            billingAddressType: response.invoiceAddressType,
            applicableTaxProfile: response.applicableTaxProfile,
            buyersPaymentTerms: response.buyersPaymentTerms,
            buyerTermsAndConditions: response.termsAndConditions, 
            portAgentId: response.portAgentId,
            portAgencyName: response.portAgencyName,
            portAgentName: response.portAgentName,
            portAgentPhoneNumber: response.portAgentPhoneNumber,
            portAgentContact: response.portAgentContact,
            portAgentPhoneFax: response.portAgentPhoneFax,
            portAgentEmail: response.emailId,  
            portAgentAddress: response.address,
            termsAndConditions: response.termsAndConditions,
            attachment: response.paymentTermsAttachments
          });
          this.uploadedAdditionalAttachmentsArray = response.paymentTermsAttachments

          this.fetchPortAgentByUserId();
          this.fetchBillingAddressByUserId();
          this.fullLoaderService.hideLoader()
       

      }



    })
    // this.fetchRfqDetails()
  }

  // Function that dismisses the notification
  dismissNotification() {
    this.showNotification = false;
  }

  nextSlide() {
    this.currentIndex =
      (this.currentIndex + 1) % this.previewDoc.length;
  }

  prevSlide() {
    this.currentIndex =
      (this.currentIndex - 1 + this.previewDoc.length) %
      this.previewDoc.length;
  }

   async togglePreview(value: boolean, section:string ,index?: number) {

     this.currentIndex = 0
     
    
     if(value){
       
      if(section == 'generalAttachment'){
      
        if(value){
  
           this.previewDoc= this.uploadedAdditionalAttachmentsArray;

           console.log("previewDoc",this.previewDoc);
           
          } else {
            this.previewDoc=[]
          } 
      }
       
     }
     else{
         this.previewDoc=[]
     }

     this.previewSection = value
    
  }
  getHeaderAttachmentCount(): any{
      
      return this.uploadedAdditionalAttachmentsArray.length;

  }


  fileOver(event:any) {
  }
  fileLeave(event:any) {
  }


  async onAddtionalFileSelected(files: NgxFileDropEntry[]) {
    try {

      this.fullLoaderService.showLoader();
      this.uploadedAdditionalAttachmentsArray =
      this.paymentFormGroup.get('attachments')?.value || [];
      
      
        if (this.uploadedAdditionalAttachmentsArray.length > 5) {
        
        throw new Error('Maximum 5 files allowed for a product!');
      }

      const fileEntries = files
        .filter((entry) => entry.fileEntry.isFile)
        .map((ele) => ele.fileEntry as FileSystemFileEntry);

        console.log(fileEntries,"fileEntries")

      if (fileEntries.length === 0) {
        throw new Error('Please upload valid files!');
      }
      if (fileEntries.length > 5) {
        throw new Error('Maximum 5 files allowed for a product!');
      }

      await new Promise((res, rej) => {
        fileEntries.map((fileEntry) => {
          fileEntry.file(async(file) => {
            let fileExt = file.name.split('.').pop();
            if (!this.acceptedAttachmentExtenstion.includes(`.${fileExt}`)) {
              // rej('Invalid filetype!');
              return;
            }

            if (file.size > this.maxFileSize) {
              throw new Error('File size must be less than 5MB!')
            }

            let uploadedAttachment:any = {
              dataUrl:'',
              name:file.name,
              file:file
              
            }

            await new Promise((res,rej)=>{
              const reader = new FileReader();
              reader.onload = (e: any) => {
                uploadedAttachment.dataUrl = e.target.result; // Store the data URL for preview
                res(true)
              };
              reader.readAsDataURL(file); // Read the file as a data URL
            })

            this.uploadedAdditionalAttachmentsArray.push(uploadedAttachment);
            res(file);
          });
        });
      });

      this.paymentFormGroup.get('attachments')?.setValue(this.uploadedAdditionalAttachmentsArray);
      this.fullLoaderService.hideLoader();

    } catch (error: any) {
      this.snack.open(error, 'OK', {
        duration: 1000,
      });
    }
  }


  openFileSelector(){

  }


  async submit(isDraft: boolean) {
    if (!isDraft) {
      this.showConfirmationDialogue = true
    }
    else {
      this.showCloseDialogue = true
      
    }

  }

  async close(isDraft: boolean) {
    if (!isDraft) {
      this.showConfirmationDialogue = true
    }
    else {
      this.showCloseDialogue = true
      
    }

  }



  // close(){}

  cancel() {
    this.showConfirmationDialogue = false
    this.showCloseDialogue = false
  }

  async selectMatTabLink(tabItem:any){

    // Check if Port Agent Details is filled before allowing tab switch
    if (!this.paymentFormGroup.get('portAgentId')?.value) {
      this.snack.open('Port Agent Details is mandatory. Please select a Port Agent before proceeding.', 'OK', {
        duration: 4000,
        panelClass: ['error-snackbar']
      });
      return;
    }

    await this.saveDraft();
    if(tabItem.route == 'header'){
      this.back()

    }

    else if(tabItem.route == 'line-items'){
      this.activatedRoute.queryParams.subscribe(async params => {

        if (params['rfqId'] != '' && params['quoteId'] != '' && params['purchaseOrderId']!='') {

          this.rfqId = params['rfqId']
          this.quoteId = params['quoteId']
          this.purchaseOrderId = params['purchaseOrderId']

          this.router.navigate([
            "operations", "createOrder", 'line-items'
          ],
            {
              queryParams: { rfqId: this.rfqId, quoteId: this.quoteId, purchaseOrderId: this.purchaseOrderId }
            }
          );

        }

      })
    }else if(tabItem.route == 'preview'){
      this.next()
    }
  }

  async next() {
    this.activatedRoute.queryParams.subscribe(async params => {

      if (params['rfqId'] != '' && params['quoteId'] != '' && params['purchaseOrderId']!='') {

        this.rfqId = params['rfqId']
        this.quoteId = params['quoteId']
        this.purchaseOrderId = params['purchaseOrderId']

        this.router.navigate([
          "operations", "createOrder", 'preview'
        ],
          {
            queryParams: { rfqId: this.rfqId, quoteId: this.quoteId, purchaseOrderId: this.purchaseOrderId }
          }
        );

      }

    })
  }

  async back() {

    this.activatedRoute.queryParams.subscribe(async params => {

        if (params['rfqId'] != '' && params['quoteId'] != '' && params['purchaseOrderId']!='') {

          this.rfqId = params['rfqId']
          this.quoteId = params['quoteId']
          this.purchaseOrderId = params['purchaseOrderId']

          this.router.navigate([
            "operations", "createOrder", 'header'
          ],
            {
              queryParams: { rfqId: this.rfqId, quoteId: this.quoteId, purchaseOrderId: this.purchaseOrderId }
            }
          );

        }

      })

  }
  
  toggleVisibility(section: string) {
    if (section == 'form1') {
     
    }
    else if (section == 'form2') {
      
    }
    
   
  }

  isPdf(urlOrDataUrl: string): boolean {
    if (urlOrDataUrl?.toLowerCase().startsWith('data:application/pdf')) {
      return true; // For data URLs, check if the MIME type is 'application/pdf'
    }
    return urlOrDataUrl?.toLowerCase().endsWith('.pdf'); // For URLs, check if it ends with '.pdf'
  }

  toggleBlur(): void {
    const element = document.querySelector('.blurry');
    if (element) {
      element.classList.toggle('blur');
    } else {
      console.warn('Element with class "blurry" not found.');
    }
  }


  async saveDraft(isDraft?:boolean){
    
    if(isDraft){
      this.showConfirmationDialogue = false;
      this.showCloseDialogue = false;
    }

    this.fullLoaderService.showLoader()

    const Comment_formObj = this.paymentFormGroup.value;
    const Comment_attachmentFiles: { [key: string]: File } = {};
    let Comment_attachmentArray = [...this.uploadedAdditionalAttachmentsArray].filter(item => item.file);

    console.log({Comment_attachmentArray});
  
    if (Comment_attachmentArray.length > 0) {
      console.log('[SAVE] Preparing attachments for upload...');
  
      const uploadPath = `purchaseOrder/${this.purchaseOrderId}/header`;
  
      try {
        // 2. Prepare S3 params for each attachment
        for (const attachment of Comment_attachmentArray) {
          const file = attachment.file;
          const fileName = file.name;
          const fileExt = fileName.split('.').pop();
          const systemName = `${uuidv4()}.${fileExt}`;
          const fileKey = `${uploadPath}/${systemName}`; // Use systemName here for uniqueness
  
          attachment.systemName = systemName;
          attachment.s3Params = {
            fileKey,
            fileContentType: file.type,
          };
  
          Comment_attachmentFiles[fileName] = file;
        }
  
        // 3. Get presigned URLs from backend
        console.log('[SAVE] Getting presigned URLs...');
        const presignedAttachments = await this.SettingsService.getBulkAttachmentUrls(Comment_attachmentArray);
  
        // 4. Upload each file to S3
        console.log('[SAVE] Uploading files to S3...');
        for (const attachment of presignedAttachments) {
          const file = Comment_attachmentFiles[attachment.name];
          const s3Path = this.awsSdkService.extractS3LocationFromUrl(attachment.s3_path);
  
          if (!file) {
            console.warn(`[UPLOAD] File not found for ${attachment.name}`);
            continue;
          }
  
          console.log(`[UPLOAD] Uploading: ${attachment.name} -> ${s3Path}`);
          await this.webApiService.putRequestExternalApi(s3Path, file);
          console.log(`[UPLOAD] Uploaded: ${attachment.name}`);
  
          // Prepare minimal clean object for saving
          attachment.s3_path = s3Path;
          attachment.fileKey = attachment.s3Params?.fileKey;
        }
  
        Comment_formObj.attachments = presignedAttachments.map((att: { name: any; systemName: any; fileKey: any; s3_path: any; }) => ({
          name: att.name,
          systemName: att.systemName,
          fileKey: att.fileKey,
          s3_path: att.s3_path,
        }));

        this.paymentFormGroup.patchValue({
          attachments: Comment_formObj.attachments
        });
  
  
      } catch (error) {
        console.error('❌ Attachment upload failed:', error);
        this.snack.open('Failed to upload attachments. Save aborted.', 'OK', { duration: 3000 });
        return;
      }
    } else {
      console.log('[SAVE] No attachments to upload.');
      Comment_formObj.attachments = [];
      this.paymentFormGroup.patchValue({
        attachments: []
      });
    }

      const params = {
        section: 'paymentTerms',
        // purchaseOrderStatus: isDraft? 14:2,
        purchaseOrderStatus: 14,
        purchaseOrderTabId:3,
        quoteId: this.quoteId,
        userId: Number(this.cookieService.get('userId')),
        purchaseOrderId:this.purchaseOrderId,
        termsConditionsAttachment: this.paymentFormGroup.get('attachments')?.value,
        billingAddressData: this.paymentFormGroup.get('billingAddress')?.value,
        billingAddressType: this.paymentFormGroup.get('billingAddress')?.value === this.billingAddress ? this.paymentFormGroup.get('billingAddressType')?.value :2,
        portAgentId: this.paymentFormGroup.get('portAgentId')?.value,
        rfqId: this.rfqId
      };

      const result = await this.purchaseOrderService.updatePurchaseOrder(params);


      if(isDraft){
        this.router.navigate(['/operations/purchase-order-list'], {
          queryParams: { 
            selectedStatus: 'Draft',
            label: 'Order'
          }
        });
      }
      this.fullLoaderService.hideLoader()

      this.snack.open(`Payment Terms Data Saved`, "OK", { duration: 3000 });

      
  }

  async fetchPortAgentByUserId() {
    this.fullLoaderService.showLoader()
    const result = await this.SettingsService.fetchPortAgentByUserId(Number(this.CookieService.get('userId')))
    this.portAgentData = result.rows

    console.log("portAgentData",this.portAgentData);
    this.fullLoaderService.hideLoader()
  }

  onPortAgentSelected(value: any) {

    const selectedPortAgent = this.portAgentData.find(portAgent => portAgent.id === value);
    console.log("selectedPortAgent",selectedPortAgent);

    this.paymentFormGroup.patchValue({

      portAgencyName: selectedPortAgent.portAgencyName,
      portAgentName: selectedPortAgent.portAgentName,
      portAgentPhoneNumber: selectedPortAgent.phone,
      portAgentContact: selectedPortAgent.contact,
      portAgentPhoneFax: selectedPortAgent.fax,
      portAgentEmail: selectedPortAgent.emailID,  
      portAgentAddress: selectedPortAgent.street,
    });
  }

  async fetchBillingAddressByUserId() {
    this.fullLoaderService.showLoader()
    const address = await this.SettingsService.fetchBranchAddressFilterValues(Number(this.CookieService.get("userId")), 2)
    this.billingAddressData = address.data
    console.log("billingAddressData",this.billingAddressData);
    this.fullLoaderService.hideLoader()
  }

}
